import { ManageTranslationPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/translation'].update({
        staticData: { title: { page: 'Translation.PageHeading' } },
        component: authGuard(ManageTranslationPage, { canManageTranslations: true })
    });
};
